import {BaseFormModel} from './base-form-model';
import {DonationProgramStatus} from '../_constants/donation-program-status';
import {Person} from './person';
import {Address} from './address';

export class DonationProgram extends BaseFormModel<DonationProgram> {
    id: number;
    name: string;
    description: string;
    imageAddress: string;
    roundUp: boolean;
    color: string;
    contrastColor: string;
    contact: Person;
    address: Address;
    status: DonationProgramStatus;
    presets: string;
}
